import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from "react-router";
import { RootState } from '../modules';

import Dialog from '../components/Alert/Dialog';
import ContentContainer from './Contents/ContentContainer';
import SidebarContainer from './Sidebar/SidebarContainer';

import { Editor } from '@tinymce/tinymce-react';
import { hiseSidebar, showSidebar } from '../modules/editor';

type MatchParams = {
	emailId: string
};

function EditorContainer({ match }: RouteComponentProps<MatchParams>) {
	const dispatch = useDispatch();
	const dialog = useSelector((state: RootState) => state.editor.ui.dialog);
	const showsBaseSidebar = useSelector((state: RootState) => state.editor.ui.showsSidebar);
	const selectedContentId = useSelector((state: RootState) => state.editor.selectedContentId);
	
	const [showSelectedSidebar, setShowSelectedSidebar] = useState(false);

	const resetIdleTime = () => {
		window.parent.postMessage({msg: 'resetIdleTime'}, '*');
	}

	useEffect(() => {
		window.parent.postMessage({msg: 'boxEditing', isEditing: selectedContentId !== -1}, '*');
	}, [selectedContentId])

	const changeSidebarStatus = (e) => {
		e.stopPropagation();
		if (selectedContentId !== -1) {
			setShowSelectedSidebar(!showSelectedSidebar);
		}

		if (showsBaseSidebar) {
			dispatch(hiseSidebar());
		} else {
			dispatch(showSidebar());
		}
	}

	useEffect(() => {
		if (selectedContentId !== -1 && showsBaseSidebar) {
			setShowSelectedSidebar(true);
		}
		if (selectedContentId === -1) {
			setShowSelectedSidebar(false);
		}
	}, [selectedContentId])

	return (
		<div
			className="stb-editor"
			onClick={resetIdleTime}
		>
			<div className="editor-container">
				<ContentContainer showBaseSidebar={showsBaseSidebar} changeSidebarStatus={changeSidebarStatus} />
				<SidebarContainer showBaseSidebar={showsBaseSidebar} showSelectedSidebar={showSelectedSidebar} />
			</div>			
			<Dialog {...dialog} />
			
			<div className="blind">				
				<Editor
					apiKey="lkuil8ct6v9pz6arod8pmx2gix11j03f19lbz0lprnbpjn0x"
					initialValue={''}
					init={{
						skin_url: '/assets/tinymce_skin/skins/ui/stb',
						icons_url: '/assets/tinymce_icon/icons/stb/icons.js',
						icons: 'stb',
						content_css: '/assets/tinymce_skin/skins/content/stb/content.css',
						language: 'ko_KR',
						language_url: '/assets/i18n/tinyMCE_ko_KR.js',
						height: 0,
						plugins: [
							'advlist lists link anchor emoticons paste image autoresize autolink',
						],
						toolbar: [
							'numlist bullist mergeTagButton stbEmoji | removeformat undo redo',
							'fontselect | fontsizeselect | stbAlign | bold italic underline strikethrough | stbForeColorPicker stbBackColorPicker | link stbUnlink', 'alignleft aligncenter alignright alignjustify '
						],
						autoresize_on_init: false,
						paste_data_images: false,
						menubar: false,
						branding: false,
						font_formats: '고딕=AppleSDGothic, noto sans, malgun gothic, dotum, sans-serif;명조=nanum myoungjo, batang, serif',
						forced_root_block: '',
						// force_br_newlines: true,
						orce_p_newlines : false,
						force_br_newlines : true,
						convert_newlines_to_brs : true,
						// remove_linebreaks : true,  						
						link_context_toolbar: false,
						link_title: false,
						link_assume_external_target: false,
						target_list: false,
						contextmenu: false,
						anchor_bottom: false,
						anchor_top: false,
						valid_elements: "p,br,b,i,strong,em,i,h1,h2,h3,h4,h5,h6,a[*],ul,ol,li,span,div",
						// paste_as_text: true,
					}}
				/>
			</div>
		</div>
	);
}

export default EditorContainer;
